<template>
  <div :class="['collection', {fold}]">
    <ul class="list" v-show="!fold">
      <li v-for="(item, index) in list" :key="item.id" ref="item">
        <img :src="item.listImg" :alt="item.title" :class="{actived: index === idx}">
        <div class="info" :class="[{actived: index === idx}]" @click="$emit('click', index)">
          <replay-item :item="generator(item)"></replay-item>
        </div>
      </li>
    </ul>
    <p class="arrow" v-show="!fold" @click="toggle">
      <svg-icon icon-class="arrow" class-name="func-btn"></svg-icon>
    </p>
    <div class="show" v-show="fold" @click="toggle"></div>
  </div>
</template>

<script>
  import ReplayItem from '../replayList/replayItem'
  export default {
    name: "collection",
    components: { ReplayItem },
    props: ['list', 'idx'],
    data() {
      return {
        fold: false
      }
    },
    mounted() {
      this.timer = setTimeout(() => {
        this.toggle()
      }, 5000)
    },
    methods: {
      toggle() {
        if (this.timer) {
          clearTimeout(this.timer)
        }
        this.fold = !this.fold
      },
      generator(item) {
        return {
          playNum: item.playNum,
          channelAvatar: item.channelAvatar,
          channelName: item.channelName,
          title: item.title,
          showType: 1,
          listImg: item.listImg
        }
      }
    },
    watch: {
      idx(index) {
        this.$refs.item[index].scrollIntoView(false)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/mixins.scss";
  .collection {
    position: absolute;
    top: 0;
    z-index: 1;
    width: 100%;
    padding-top: 30px;
    overflow: hidden;
    background: rgba(0, 0, 0, .4);
    &.fold {
      background: transparent;
    }
  }
  .list {
    display: flex;
    align-items: center;
    overflow-y: scroll;
    padding-left: 10px;
    margin-left: 20px;
    li {
      flex-shrink: 0;
      overflow: hidden;
      position: relative;
    }
    img {
      width: 180px;
      height: 240px;
      margin-right: 20px;
      &.actived {
        opacity: 0.8;
        border: 4px solid #FFFFFF;
        border-radius: 6px;
      }
    }
    .info {
      position: absolute;
      top: 0;
      left: 0;
      width: 330px;
      height: 482px;
      transform-origin: left top;
      transform: scale((180/330), (240/482));
      /deep/ .preview-box {
        .notice-box {
          transform-origin: left;
          transform: scale(1.2);
        }
        .icon-nav {
          transform-origin: right;
          transform: scale(1.2);
        }
      }
      /deep/ .info-box {
        img {
          width: 60px !important;
          height: 60px !important;
          flex-shrink: 0;
        }
        span {
          font-size: 38px;
        }
        .info-subheading {
          font-size: 32px;
        }
        transform-origin: left top;
      }
      &.actived {
        top: 4px;
        left: 4px;
      }
    }
  }
  .arrow {
    text-align: center;
    padding: 40px;
  }
  .svg-icon {
    transform: scaleX(2.3) rotate(-90deg);
  }
  .show {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    margin: auto;
    background: rgba(0, 0, 0, .3) url('../../assets/images/collect-show.png') no-repeat center / 28px 20px;
  }
</style>